import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
  appBar: {
    boxShadow: '0 1px 8px rgba(0,0,0,.3)',
    position: 'relative',
    color: '#0b1323',
    backgroundColor: 'white',
    minHeight: 70,
    zIndex: theme.zIndex.drawer + 100,
    [theme.breakpoints.down('sm')]: {
      position: 'fixed'
    }
  },
  addPaymentButton: {
    padding: '8px 16px 9px 12px',
    borderRadius: 4,
    backgroundColor: '#0033cc',
    color: 'white',
    textTransform: 'capitalize',
    fontSize: 14,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.43,
    letterSpacing: 'normal',
    marginRight: '16px',
    '&:hover': {
      backgroundColor: '#0033cc'
    }
  },
  grow: {
    flexGrow: 1,
  },
  toolBar: {
    paddingLeft: 0,
    paddingRight: 0,
    minHeight: 70
  },
  branding: {
    cursor: 'pointer',
    color: '#0b1323',
    margin: 0,
    minHeight: 70,
    alignItems: 'center',
    paddingLeft: 16,
    backgroundColor: '#fff',
    minWidth: 270,
    maxWidth: 270,
    display: 'flex',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    //margin: 'auto 0',
    lineHeight: '50px',
    padding: `0 0 0 0`,
    cursor: 'pointer',
    "&:hover": {
      backgroundColor: '#F1F3F4'
    },
  },
  logo: {
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '80px'
    }
  },
  userBadge: {
    marginLeft: '1.35em',
    display: 'flex',
    alignItems: 'center'
  },
  circle: {
    borderRadius: "45%",
    backgroundColor: "#2d9d78",
    fontSize: 12,
    color: "#2d9d78",
  },
  singleTripCircle: {
    borderRadius: "45%",
    backgroundColor: "black",
    fontSize: 12,
    color: "black",
  },
  separatorCircle: {
    borderRadius: "50%",
    backgroundColor: "lightgrey",
    fontSize: 12,
    color: "lightgrey",
  },
  circleOnTrip: {
    borderRadius: "45%",
    backgroundColor: "#2680eb",
    fontSize: 12,
    color: "#2680eb",
  },
  spanV2: {
    fontSize: 18,
    color: '#6b778c',
    marginLeft: 16
  },
  spanV4: {
    fontSize: 21,
    color: 'black',
    marginLeft: 16
  },
  mlV2: {
    marginLeft: 16
  },
  mlV1: {
    marginLeft: 27
  },
  userInfo: {
    marginRight: 10,
    width: '100%',
    maxWidth: '150px',
    minWidth: '150px',
    display: 'inline-block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    lineHeight: '20px'
  },
  companyName: {
    fontSize: 12,
    fontWeight: 600
  },
  userName: {
    fontSize: 12,
    fontWeight: 300
  },
  userIcon: {
    fontSize: 40,
    marginRight: 10
  },
  thumbnail: {
    fontSize: 40,
    backgroundColor: '#fff',
    marginLeft: 30,
    borderRadius: 4,
  },
  thumbnailText: {
    marginLeft: 30,
    fontWeight: 300,
    fontSize: 24,
    display: 'flex',
    alignItems: 'center'
  },
  thumbnailTextV1: {
    fontWeight: 300,
    fontSize: 24
  },
  endDiv: {
    marginRight: 30,
    display: 'flex',
    alignItems: 'center'
  },
  addExpenseButton: {
    backgroundColor: '#00875a', color: 'white', borderRadius: '4px', textTransform: 'none', fontWeight: 'bold', paddingRight: '16px', paddingLeft: '12px', paddingTop: '7px', paddingBottom: '7px', marginRight: 16,
    "&:hover": {
      backgroundColor: '#00875a'
    }
  },
  addTruckButton: {
    backgroundColor: '#0033cc', color: 'white', borderRadius: '4px', textTransform: 'none', fontWeight: 'bold', paddingRight: '16px', paddingLeft: '12px', paddingTop: '7px', paddingBottom: '7px', marginRight: 67,
    "&:hover": {
      backgroundColor: '#0033cc'
    }
  },
  addTruckButtonFastag: {
    backgroundColor: '#00875a', color: 'white', borderRadius: '4px', textTransform: 'none', fontWeight: 'bold', paddingRight: '16px', paddingLeft: '12px', paddingTop: '7px', paddingBottom: '7px', marginRight: -4,
    "&:hover": {
      backgroundColor: '#00875a'
    }
  },
  driverGaveButton: {
    color: '#de1c22', textTransform: 'none', paddingTop: '8px', paddingBottom: '7px', paddingLeft: '18px', paddingRight: '18px', fontWeight: 300, border: '1px solid', borderRadius: '4px', marginRight: '16px'
  },
  driverGotButton: {
    color: '#00875a', textTransform: 'none', paddingTop: '8px', paddingBottom: '7px', paddingLeft: '18px', paddingRight: '18px', fontWeight: 300, border: '1px solid', border: '1px solid', borderRadius: '4px', marginRight: '16px'
  },
  driverGaveButtonV1: {
    backgroundColor: '#de1c22', color: 'white', textTransform: 'none', paddingTop: '8px', paddingBottom: '7px', paddingLeft: '18px', paddingRight: '18px', fontWeight: 300, borderRadius: '4px', marginRight: '16px',
    "&:hover": {
      backgroundColor: '#de1c22'
    }
  },
  driverGotButtonV1: {
    backgroundColor: '#00875a', color: 'white', textTransform: 'none', paddingTop: '8px', paddingBottom: '7px', paddingLeft: '18px', paddingRight: '18px', fontWeight: 300, borderRadius: '4px', marginRight: '16px',
    "&:hover": {
      backgroundColor: '#00875a'
    }
  },
  addDriverButton: {
    backgroundColor: '#0033cc', color: 'white', textTransform: 'none', paddingTop: '8px', paddingBottom: '7px', paddingLeft: '12px', paddingRight: '16px', fontWeight: 300, borderRadius: '4px', marginRight: 65,
    "&:hover": {
      backgroundColor: '#0033cc'
    }
  },
  moreButton: {
    color: '#6b778c', paddingLeft: 18, paddingRight: 18, paddingTop: 8, paddingBottom: 7, textTransform: 'capitalize',
    "&:hover": {
      color: '#6b778c'
    }
  },
  moreButtonV1: {
    color: '#6b778c', paddingLeft: 18, paddingRight: 18, paddingTop: 8, paddingBottom: 7, textTransform: 'capitalize', marginLeft: 16,
    "&:hover": {
      color: '#6b778c'
    }
  },
  editMenuIcon: { fontSize: 17, borderBottom: '2px solid #0033CC', color: '#0033cc' },
  miV1: {
    fontWeight: 300,
    paddingTop: '12px', paddingBottom: '12px'
  },
  singleVehicleMenuPaper: {
    width: 170,
    marginRight: '6px'
  },
  deleteMenu: {
    fontWeight: 300,
    paddingTop: '12px', paddingBottom: '12px'
  },
  divV25: {
    fontWeight: 'bold', fontSize: '16px'
  },
  mtV5: {
    marginTop: '8px'
  },
  singleVehicleMenu: {
    position: "absolute",
    zIndex: 10000,
    top: "7%",
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
  },
  cancelV1: {
    color: '#6b778c', fontWeight: 'bold', fontSize: '16px', marginRight: '6px', letterSpacing: '0.05em'
  },
  deleteV1: {
    color: 'red', fontWeight: 'bold', fontSize: '16px', letterSpacing: '0.05em'
  },
  divV7: {
    width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginTop: '21px'
  },
  confirmV1: {
    backgroundColor: 'black',
    color: 'white',
    textTransform: 'capitalize',
    fontWeight: 300,
    paddingLeft: 36,
    paddingRight: 36,
    paddingTop: 9,
    paddingBottom: 11,
    "&:hover": {
      backgroundColor: 'black'
    }
  },
  dialogTitleV1: {
    paddingLeft: 30, paddingTop: 16, paddingBottom: '16px !important',
    '& .MuiTypography-root': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    }
  },
  cancelButton: {
    textTransform: 'capitalize', marginRight: '16px', fontWeight: 300, backgroundColor: '#f6f7f9', paddingLeft: '20px', paddingRight: 20, paddingTop: 9, paddingBottom: 11,
    "&:hover": {
      backgroundColor: '#f6f7f9'
    }
  },
  colorV1: {
    color: '#6b778c'
  },
  mrV1: {
    marginRight: 8
  },
  addPartyCta: {
    backgroundColor: '#0033cc',
    borderRadius: 4,
    border: 0,
    color: 'white',
    height: 36,
    padding: '7px 16px 7px 12px',
    margin: '0 16px',
    textTransform: 'capitalize'
  },
  addTripCta: {
    backgroundColor: '#00875a',
    borderRadius: 4,
    border: 0,
    color: 'white',
    height: 36,
    padding: '7px 26px 7px 12px',
    margin: '0 16px',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#00875a'
    }
  },
  addShopCta: {
    backgroundColor: '#5170f0',
    borderRadius: 4,
    border: 0,
    color: 'white',
    height: 36,
    padding: '7px 26px 7px 12px',
    margin: '0 16px',
    fontWeight: 600,
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: '#5170f0'
    }
  },
  editTripCta: {
    backgroundColor: 'white',
    borderRadius: 4,
    color: '#1461d2',
    height: 36,
    minWidth: 80,
    padding: '8px',
    margin: '0 8px',
    textTransform: 'capitalize',
    border: 'solid 1px #1461d2'
  },
  editTripCtaV1: {
    backgroundColor: 'white',
    borderRadius: 4,
    color: '#1461d2',
    minWidth: 80,
    padding: '8px',
    paddingTop: 6,
    paddingBottom: 6,
    textTransform: 'capitalize',
    border: 'solid 1px #1461d2',
    marginTop: 1

  },
  deleteTripCta: {
    backgroundColor: 'white',
    borderRadius: 4,
    color: '#de1c22',
    minWidth: 80,
    height: 36,
    padding: '8px',
    margin: '0 8px',
    textTransform: 'capitalize',
    border: 'solid 1px #de1c22'
  },
  deleteTripCtaV1: {
    backgroundColor: 'white',
    borderRadius: 4,
    color: '#de1c22',
    minWidth: 80,
    padding: '8px',
    paddingTop: 6,
    paddingBottom: 6,
    marginRight: 16,
    marginLeft: 16,
    textTransform: 'capitalize',
    border: 'solid 1px #de1c22',
    marginTop: 1
  },
  subTitleBullet: {
    borderRadius: "50%",
    backgroundColor: "#161f34",
    fontSize: 12,
    color: "#161f34",
    margin: "0px 6px",
    marginTop: -2
  },
  subTitleBulletV1: {
    borderRadius: "50%",
    backgroundColor: "#161f34",
    fontSize: 12,
    color: "#161f34",
    marginLeft: 16,
    marginRight: 16,
    marginTop: -2
  },
  reminderBullet: {
    borderRadius: "50%",
    backgroundColor: "#161f34",
    fontSize: 8,
    color: "#161f34",
    margin: "0px 6px",
    //marginTop: -2
  },
  editButtonV1: {
    color: '#0033cc',
    fontSize: 18,
    textTransform: 'capitalize',
    paddingLeft: 18,
    paddingRight: 18,
    paddingTop: 4,
    paddingBottom: 4,
    marginRight: 30
  },
  iconlabel: {
    width: 20,
    '& .MuiSvgIcon-root': {
      fontSize: 20
    }
  },
  spanV3: {
    color: '#00875a',
    marginLeft: 10
  },
  addExpenseButtonVehicle: {
    color: 'white', textTransform: 'capitalize', backgroundColor: 'red', fontWeight: 'bold', marginRight: 16,
    "&:hover": {
      backgroundColor: 'red'
    }
  },
  addTripButtonVehicle: {
    color: 'white', textTransform: 'capitalize', backgroundColor: '#00875a', fontWeight: 'bold', marginRight: 6,
    "&:hover": {
      backgroundColor: '#00875a'
    }
  },
  rechargeFastagButtonVehicle: {
    color: 'white',
    textTransform: 'capitalize',
    backgroundColor: '#0033cc',
    fontWeight: 'bold',
    marginRight: 6,
    "&:hover": {
      backgroundColor: '#0033cc'
    }
  },
  addPaymentButtonVehicle: {
    color: 'white', textTransform: 'capitalize', backgroundColor: '#0033CC', fontWeight: 'bold', marginRight: 6,
    "&:hover": {
      backgroundColor: '#0033CC'
    }
  },
  addSupplierButton: {
    "&:hover": {
      backgroundColor: '#0033cc'
    },
    backgroundColor: '#0033cc',
    borderRadius: 4,
    border: 0,
    color: 'white',
    height: 36,
    padding: '7px 16px 7px 12px',
    margin: '0 16px',
    textTransform: 'capitalize'
  },
  fsV1: {
    fontSize: '26px !important'
  },
  obAdd: {
    fontSize: 17,

  },
  ptV1: {
    paddingTop: 2
  },
  mtV3: {
    marginTop: 6
  },
  menuItemV1: {
    paddingTop: 10, paddingBottom: 8, paddingLeft: 20, paddingRight: 20, marginLeft: 4, color: '#0033cc'
  },
  menuItemV2: {
    paddingTop: 10, paddingBottom: 8, paddingLeft: 20, paddingRight: 20, color: 'red',
  },
  menuItemV3: {
    paddingTop: 10, paddingBottom: 8, paddingLeft: 20, paddingRight: 20,
  },
  reminderCard: {
    marginLeft: 40,
    padding: '5px 40px',
    backgroundColor: '#fed49a',
    borderRadius: 8,
    fontSize: 16
  },
  reminderDate: {
    fontWeight: 600
  },
  iconButtonV1: {
    marginLeft: '-4px'
  },
  closeButton: {
    fontSize: 18,
    color: '#e0e0e0',
  },
  ownTruck: {
    backgroundColor: '#0033cc',
    color: 'white',
    fontSize: 16,
    fontWeight: 'bold',
    paddingLeft: 12,
    paddingRight: 12,
    borderRadius: 8,
    paddingTop: 1,
    paddingBottom: 3,
    letterSpacing: '2px',
    marginLeft: 16
  },
  marketTruck: {
    backgroundColor: '#e86825',
    color: 'white',
    fontSize: 16,
    fontWeight: 'bold',
    paddingLeft: 12,
    paddingRight: 12,
    borderRadius: 8,
    paddingTop: 1,
    paddingBottom: 3,
    letterSpacing: '2px',
    marginLeft: 16
  },
  marginV1: {
    marginTop: 8
  },
  simTrackingSubtitle: {
    color: 'grey',
    fontSize: 14
  },
  divAlign: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  arrowIcon: {
    color: 'black', fontSize: 30
  },
  divTour: {
    display: 'flex',
    color: 'white'
  },
  tourV1: {
    backgroundColor: '#4D4D4D',
    boxShadow: 'none',
    border: '1px solid #4D4D4D',
    marginTop: '1.2em',
    fontSize: '48px',
    width: 'auto',
    marginLeft: '1.9em',
    maxWidth: 'initial',
    padding: '0px !important',
    transition: 'none !important'
  },
  tourText: {
    marginRight: 8,
    marginTop: 48
  },
  addUserButton: {
    color: 'white',
    textTransform: 'capitalize',
    fontWeight: 500,
    fontSize: 14,
    backgroundColor: '#0033cc',
    borderRadius: 4,
    paddingTop: 7,
    paddingBottom: 7,
    paddingLeft: 18,
    paddingRight: 18,
    '&:hover': {
      backgroundColor: '#0033cc'
    }
  },
  addInvoiceButton: {
    color: 'white',
    textTransform: 'capitalize',
    fontWeight: 500,
    fontSize: 14,
    backgroundColor: '#0033cc',
    borderRadius: 4,
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 12,
    paddingRight: 15,
    '&:hover': {
      backgroundColor: '#0033cc'
    }
  },
  mtV6: {
    marginTop: '-0.04em'
  },
  subTitleBulletV1: {
    marginLeft: 16,
    marginRight: 12,
    color: '#c4c4c4',
    fontSize: 16
  },
  subTitleV1: {
    fontSize: '18px',
    color: '#0b1323'
  },
  colorRed: {
    color: '#ff0000'
  },
  editInvoice: {
    border: '1px solid #0033cc',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 4,
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 12,
    paddingRight: 16,
    color: '#0033cc',
    marginRight: 16
  },
  deleteInvoice: {
    border: '1px solid #ff0000',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 4,
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 12,
    paddingRight: 16,
    color: '#ff0000',
    marginRight: 32
  },
  addPaymentButtonInvoice: {
    backgroundColor: '#0033cc',
    color: 'white',
    fontWeight: 600,
    borderRadius: 4,
    fontSize: 16,
    paddingTop: 7,
    paddingBottom: 7,
    paddingLeft: 14,
    paddingRight: 16,
    textTransform: 'none',
    marginRight: 16,
    '&:hover': {
      backgroundColor: '#0033cc'
    }
  },
  pdfPreviewInvoice: {
    backgroundColor: '#00875a',
    color: 'white',
    fontWeight: 600,
    borderRadius: 4,
    fontSize: 16,
    paddingTop: 7,
    paddingBottom: 7,
    paddingLeft: 14,
    paddingRight: 16,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#00875a'
    }
  },
  pdfIcon: {
    color: 'white',
    fontSize: 16
  },
  editIcon: {
    fontSize: 15
  },
  confirmButtonInvoice: {
    backgroundColor: '#161f34',
    color: 'white',
    fontWeight: 600,
    borderRadius: 4,
    fontSize: 16,
    paddingTop: 7,
    paddingBottom: 7,
    paddingLeft: 14,
    paddingRight: 16,
    marginRight: 16,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#161f34'
    }
  },
  doneIconV1: {
    fontSize: 16
  },
  switch: {
    '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#0033cc'
    },
    '& .MuiSwitch-colorSecondary.Mui-checked': {
      color: '#0033cc'
    }
  },
  helpIconWhite: {
    color: 'white'
  },
  helpButtonBlack: {
    backgroundColor: '#161f34 !important',
    borderRadius: 4,
    color: 'white !important',
    textTransform: 'none',
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 12,
    paddingRight: 12,
    fontSize: 14,
    boxShadow: 'none !important',
    '&:hover': {
      backgroundColor: '#161f34 !important'
    }
  },
  dieselCardRecharge: {
    padding: '6px 16px 6px 12px',
    borderRadius: '4px',
    backgroundColor: '#00885a',
    color: 'white',
    textTransform: 'none !important',
    marginRight: 16,
    boxShadow: 'none !important',
    "&:hover": {
      backgroundColor: '#00885a'
    }
  },
  blueColor: {
    color: '#2652d4'
  },
  ml4: {
    marginLeft: 4
  },
  divAlignV1: {
    display: 'flex',
    alignItems: 'center'
  },
  divMargin: {
    marginLeft: 16,
    marginRight: 16,
    marginTop: '-4px'
  }
}));

export default useStyles;
